export const baiduConsult = () => {
    if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerender) return;

    const insertScriptOnce = (id, src, onload) => {
        if (document.getElementById(id)) return;

        const script = document.createElement("script");
        script.id = id;
        script.src = src;
        script.async = true;

        if (onload) {
            script.onload = script.onreadystatechange = function () {
                const readyState = this.readyState;
                if (readyState && readyState !== "loaded" && readyState !== "complete") return;
                onload();
                script.onload = script.onreadystatechange = null;
            };
        }

        const firstScript = document.getElementsByTagName("script")[0];
        firstScript.parentNode.insertBefore(script, firstScript);
    };

    const loadTrackers = () => {
        window._hmt = window._hmt || [];
        insertScriptOnce(
            "baidu-hm-script",
            "https://hm.baidu.com/hm.js?351bfbeef4cc857f552b8114a57c9c93",
        );

        window.uetq = window.uetq || [];
        insertScriptOnce(
            "bing-uet-script",
            "//bat.bing.com/bat.js",
            () => {
                const options = { ti: "343134183", enableAutoSpaTracking: true };
                options.q = window.uetq;
                window.uetq = new UET(options);
                window.uetq.push("pageLoad");
            },
        );

        window.clarity = window.clarity || function () {
            (window.clarity.q = window.clarity.q || []).push(arguments);
        };
        insertScriptOnce("clarity-script", "https://www.clarity.ms/tag/sf239qmjbg");
    };

    if (document.readyState === "complete") {
        loadTrackers();
    } else {
        window.addEventListener("load", loadTrackers, { once: true });
    }

    bindMobileConsultClose();
    hideMobileInvite();
}

const bindMobileConsultClose = () => {
    if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerender) return;
    if (window.__plmConsultCloseBound) return;
    window.__plmConsultCloseBound = true;
    try {
        sessionStorage.removeItem("plm-consult-closed");
    } catch (e) { /* ignore */ }

    const isMobile = () => window.matchMedia("(max-width: 767px)").matches;

    const isIconBox = (el) => {
        if (!el || el.id === "app" || el.id === "mobile-consult-close") return false;
        if (el.id === "aff-im-root") return false;
        const style = window.getComputedStyle(el);
        if (style.position !== "fixed") return false;
        if (style.display === "none" || Number(style.opacity) === 0) return false;
        const rect = el.getBoundingClientRect();
        return (
            rect.width >= 40 &&
            rect.width <= 200 &&
            rect.height >= 40 &&
            rect.height <= 240 &&
            rect.left > window.innerWidth * 0.55
        );
    };

    const findConsultIcon = () => {
        const roots = [
            document.getElementById("aff-im-root"),
            document.getElementById("newBridge"),
            document.body,
        ].filter(Boolean);
        let found = null;
        roots.some((root) => {
            const list = root === document.body
                ? Array.from(document.body.children)
                : [root].concat(Array.from(root.querySelectorAll("*")));
            return list.some((el) => {
                if (isIconBox(el)) {
                    found = el;
                    return true;
                }
                if (root === document.body) {
                    return Array.from(el.children).some((child) => {
                        if (isIconBox(child)) {
                            found = child;
                            return true;
                        }
                        return false;
                    });
                }
                return false;
            });
        });
        return found;
    };

    const placeButton = (btn, icon) => {
        if (!icon) return;
        const rect = icon.getBoundingClientRect();
        btn.style.right = `${Math.max(4, window.innerWidth - rect.left + 4)}px`;
        btn.style.top = `${Math.max(4, rect.top)}px`;
        btn.style.bottom = "auto";
        btn.style.left = "auto";
        btn.style.zIndex = "2147483647";
    };

    const mountButton = () => {
        if (!isMobile() || document.getElementById("mobile-consult-close")) return;
        if (document.documentElement.classList.contains("consult-icon-hidden")) return;

        const btn = document.createElement("button");
        btn.id = "mobile-consult-close";
        btn.type = "button";
        btn.setAttribute("aria-label", "关闭在线咨询");
        btn.textContent = "×";
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            const icon = findConsultIcon();
            if (icon) icon.style.setProperty("display", "none", "important");
            document.documentElement.classList.add("consult-icon-hidden");
            btn.remove();
        });
        document.body.appendChild(btn);
        placeButton(btn, findConsultIcon());
        return btn;
    };

    let tries = 0;
    const sync = () => {
        if (!isMobile()) return;
        const btn = document.getElementById("mobile-consult-close") || mountButton();
        if (!btn) return;
        const icon = findConsultIcon();
        if (icon) placeButton(btn, icon);
        if (!icon && tries++ < 24) setTimeout(sync, 500);
    };

    if (document.readyState === "complete") {
        setTimeout(sync, 300);
    } else {
        window.addEventListener("load", () => setTimeout(sync, 300), { once: true });
    }
}

const INVITE_SELECTORS = [
    "#nb_invite_ok",
    "#nb_invite_wrap",
    "#BDBridgeInviteWrap",
    ".nb-invite-wrap",
    "#QIAO_INVITE_CONTAINER",
    "#qiao-invite-wrap",
    "#qiao-invite-container",
];

const hideMobileInvite = () => {
    if (window.__PRERENDER_INJECTED && window.__PRERENDER_INJECTED.isPrerender) return;
    if (window.__plmInviteHiddenBound) return;
    window.__plmInviteHiddenBound = true;

    const isMobile = () => window.matchMedia("(max-width: 767px)").matches;

    const hide = (el) => {
        if (!el || el.id === "app" || el.id === "aff-im-root" || el.id === "mobile-consult-close") return;
        el.style.setProperty("display", "none", "important");
        el.style.setProperty("visibility", "hidden", "important");
        el.style.setProperty("pointer-events", "none", "important");
    };

    const isInviteBar = (el) => {
        if (!el || el.nodeType !== 1) return false;
        if (el.id === "app" || el.id === "aff-im-root" || el.id === "mobile-consult-close") return false;
        const text = (el.innerText || "").replace(/\s+/g, "");
        if (
            !text.includes("欢迎来到本网站") &&
            !(text.includes("现在咨询") && text.includes("稍后再说"))
        ) {
            return false;
        }
        const rect = el.getBoundingClientRect();
        if (rect.width < 80 || rect.height < 36 || rect.height > 320) return false;
        return rect.width > window.innerWidth * 0.55 || rect.top > window.innerHeight * 0.45;
    };

    const sweep = () => {
        if (!isMobile()) return;
        INVITE_SELECTORS.forEach((sel) => {
            document.querySelectorAll(sel).forEach(hide);
        });
        const roots = [document.body, document.getElementById("aff-im-root")].filter(Boolean);
        roots.forEach((root) => {
            const list = root === document.body
                ? Array.from(document.body.children)
                : Array.from(root.children);
            list.forEach((el) => {
                if (isInviteBar(el)) {
                    hide(el);
                    return;
                }
                Array.from(el.children || []).forEach((child) => {
                    if (isInviteBar(child)) hide(child);
                });
            });
        });
    };

    const run = () => {
        sweep();
        let n = 0;
        const timer = setInterval(() => {
            sweep();
            if (++n > 40) clearInterval(timer);
        }, 500);
    };

    if (document.readyState === "complete") {
        setTimeout(run, 300);
    } else {
        window.addEventListener("load", () => setTimeout(run, 300), { once: true });
    }
}
